export default __webpack_public_path__ + "statistics-section-v2.png";